



















































































import Vue from "vue";
import CardProperty from "./CardProperty.vue";
import { UserGroupMini } from "@/api/UserGroupMini";
import storeHelper from "@/store/store-helper";
import ModernApiController from "@/api/ModernApiController";
import { UserGetDto } from "@/api/UserGetDto";
import utils from "@/utils";
import { OwnUserGetDto } from "@/api/OwnUserGetDto";

export default Vue.extend({
    name: "UserCard",
    components: { CardProperty },
    props: {
        /** The user represented by this card */
        user: { type: Object as () => OwnUserGetDto, required: true }
    },
    data: function () {
        return {
            /** model for the tab selector */
            tab: null as number,
            groups: [] as UserGroupMini[],
            currentUser: null as OwnUserGetDto
        };
    },
    async mounted() {
        this.getSortedUserGroupsWithoutSystemGroups();
        this.currentUser = await storeHelper.userStore.getLoggedOnUser();
    },
    computed: {
        /** Gets the id of the card */
        cardId(): string {
            return `extraInfoCard_${this.user.user_id}`;
        },
        /** gets whether the user on this card has organisation units */
        hasOrganisationalUnits(): boolean {
            return this.user.organization_units && this.user.organization_units.length > 0;
        },
        isOutOfOffice(): boolean {
            var today = new Date();
            return this.user.out_of_office != null && this.user.out_of_office.from != null && today > this.user.out_of_office.from.toDate();
        },
        hasOutOfOfficeTo(): boolean {
            return this.user.out_of_office.to != null;
        }
    },
    methods: {
        /** Gets the names of the organisation units of the user
         * @returns The names of the user's organisation units
         */
        getOrganizationUnitNames(): string {
            return this.user.organization_units.map(ou => ou.name).join();
        },
        /** Gets the user groups the user is in (but not the system groups), sorted by alphabet
         * @returns the user groups of the user, sorted by alphabet
         */
        async getSortedUserGroupsWithoutSystemGroups(): Promise<void> {
            const userDetails = await ModernApiController.getAsync<UserGetDto>(`users/${this.user.user_id}?include_user_groups=true`);
            this.groups = (userDetails?.user_groups || [])
                ?.filter(ug => !utils.isSystemUserGroup(ug.user_group_id))
                .sort((a, b) => {
                    const texta: string = a.name.toUpperCase();
                    const textb: string = b.name.toUpperCase();
                    return texta < textb ? -1 : texta > textb ? 1 : 0;
                });
        },
        /** closes the card (by emitting 'close') */
        closeCard(): void {
            this.$emit("close");
        },
        dateToUserFormat: function (itemDate: string): string {
            return utils.formatDate(itemDate.toDate(), this.currentUser?.date_format);
        }
    }
});
